import { render, staticRenderFns } from "./ProductFamilyDialog.vue?vue&type=template&id=2c1fbc6c"
import script from "./ProductFamilyDialog.vue?vue&type=script&lang=ts"
export * from "./ProductFamilyDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports